angular.module('unergie.main')
.controller('adjustMonthlyPaymentsModalCtrl', ($scope, $uibModalInstance, ErrorCatcher, MetaWatcher, DraftsBasic, idDraftBasic, selectedAdjustment) => {
    $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
    $scope.isNotified = false
    $scope.close = $uibModalInstance.dismiss
    $scope.adjustMonthlyPayments = () => {
        if (selectedAdjustment.value === 0) {
            return Promise.resolve({ estimated_amendment: null })
        }
        return DraftsBasic.adjustMonthlyPaymentsEstimation({ id_draft_basic: idDraftBasic }, { priceModifPercentage: selectedAdjustment.value })
        .$promise.then((result) => result)
    }
    $scope.saveModifications = () => {
        return $scope.adjustMonthlyPayments().then((payload) => {
            return $scope.saveDraft({ draftElec: payload }, true).then(() => $uibModalInstance.close())
        }).catch((error) => {
            ErrorCatcher(error)
            throw error
        })
    }
})
